import AppointmentBookOnlineWidgetView
    from "views/AppointmentBookOnlineWidgetView/AppointmentBookOnlineWidgetView";


export default function AppointmentBookOnlineWidget() {
    return (
        <AppointmentBookOnlineWidgetView />
    );
};
